module.exports = __webpack_public_path__ + "static/media/ubuntu.3f3d48ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/ubuntu.png
// module id = 208
// module chunks = 0